import { render } from "./Agregator.vue?vue&type=template&id=3b1d38a9"
import script from "./Agregator.vue?vue&type=script&lang=js"
export * from "./Agregator.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__